import type { ButtonProps } from './Button'
import type { CustomStyleOverrideProps } from './types'

export const getBrandColor = (
  props?: Partial<CustomStyleOverrideProps>,
  variant?: ButtonProps['variant']
) => {
  if (props?.brandColor) return props.brandColor
  switch (variant) {
    case 'primary':
      return 'var(--brand-primary)'
    case 'secondary':
      return 'var(--brand-secondary)'
    default:
      return 'var(--brand-primary)'
  }
}

export const getActiveBrandColor = (
  props?: Partial<CustomStyleOverrideProps>,
  variant?: ButtonProps['variant']
) => {
  if (props?.brandColor) return props.brandColor
  switch (variant) {
    case 'primary':
      return 'var(--button-primary-background-hover)'
    case 'secondary':
      return 'var(--button-secondary-background-hover)'
    default:
      return 'var(--brand-primary)'
  }
}

export const getDangerColor = (props?: Partial<CustomStyleOverrideProps>) => {
  if (props?.dangerColor) return props.dangerColor
  return 'var(--danger)'
}

export const getBorderColor = (
  props?: Partial<CustomStyleOverrideProps>,
  variant?: ButtonProps['variant']
) => {
  if (props?.borderColor) return props.borderColor
  switch (variant) {
    case 'primary':
      return 'var(--button-primary-border)'
    case 'secondary':
      return 'var(--button-secondary-border)'
    case 'tertiary':
      return 'var(--black)'
    case 'info':
      return 'var(--info)'
    default:
      return 'var(--gray200)'
  }
}

export const getHoverBorderColor = (
  props?: Partial<CustomStyleOverrideProps>,
  variant?: ButtonProps['variant']
) => {
  if (props?.borderColor) return props.borderColor
  switch (variant) {
    case 'primary':
      return 'var(--button-primary-border)'
    case 'secondary':
      return 'var(--border)'
    case 'tertiary':
      return 'var(--black)'
    case 'info':
      return 'var(--info)'
    default:
      return 'var(--gray200)'
  }
}

export const getActiveBorderColor = (
  props?: Partial<CustomStyleOverrideProps>,
  variant?: ButtonProps['variant']
) => {
  if (props?.borderColor) return props.borderColor
  switch (variant) {
    case 'primary':
      return 'var(--button-primary-border)'
    case 'secondary':
      return 'var(--brand-primary)'
    case 'tertiary':
      return 'var(--black)'
    case 'info':
      return 'var(--info)'
    default:
      return 'var(--gray200)'
  }
}

export const getBorderRadius = (
  props?: Partial<CustomStyleOverrideProps>,
  variant?: ButtonProps['variant']
) => {
  if (props?.borderRadius) return props.borderRadius
  switch (variant) {
    case 'primary':
      return 'var(--button-primary-border-radius)'
    case 'secondary':
      return 'var(--button-secondary-border-radius)'
    default:
      return 'var(--border-radius-lg)'
  }
}

export const getTextColor = (
  props?: Partial<CustomStyleOverrideProps>,
  variant?: ButtonProps['variant']
) => {
  if (props?.textPrimaryColor) return props.textPrimaryColor
  switch (variant) {
    case 'primary':
      return 'var(--button-primary-text)'
    case 'secondary':
      return 'var(--button-secondary-text)'
    case 'tertiary':
    case 'info':
      return 'var(--white)'
    default:
      return 'var(--text-primary)'
  }
}

export const getBackgroundColor = (
  props?: Partial<CustomStyleOverrideProps>,
  variant?: ButtonProps['variant']
) => {
  if (props?.backgroundColor) return props.backgroundColor
  switch (variant) {
    case 'primary':
      return 'var(--button-primary-background)'
    case 'secondary':
      return 'var(--button-secondary-background)'
    case 'tertiary':
      return 'var(--black)'
    case 'info':
      return 'var(--info)'
    default:
      return 'var(--gray100)'
  }
}

export const getHoverBackgroundColor = (
  props?: Partial<CustomStyleOverrideProps>,
  variant?: ButtonProps['variant']
) => {
  if (props?.backgroundColor) return props.backgroundColor
  switch (variant) {
    case 'primary':
      return 'var(--button-primary-background-hover)'
    case 'secondary':
      return 'var(--button-secondary-background-hover)'
    case 'tertiary':
      return 'var(--surface-primary)'
    case 'info':
      return 'var(--info)'
    default:
      return 'var(--gray100)'
  }
}

export const getActiveBackgroundColor = (
  props?: Partial<CustomStyleOverrideProps>,
  variant?: ButtonProps['variant']
) => {
  if (props?.backgroundColor) return props.backgroundColor
  switch (variant) {
    case 'primary':
      return 'var(--button-primary-background-hover)'
    case 'secondary':
      return 'var(--button-secondary-background-hover)'
    case 'tertiary':
      return 'var(--surface-primary)'
    case 'info':
      return 'var(--info)'
    default:
      return 'var(--gray100)'
  }
}
